// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?63b6e6fd6a4db1d7b04b26976301d0179d5c07f2";
};